import { GoogleLogin } from '@react-oauth/google'
import { Box, Flex, retriever } from '@retriever-ui/react'
import { GoogleIcon } from 'src/assets/icons/google.icon'
import { notify } from 'src/components/alert/toast'
import useToRedirect from 'src/hooks/use-to-redirect'

import { useAuth } from '../auth-context'

const decodeGoogleJwt = (token: string) => {
  const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
  return JSON.parse(window.atob(base64))
}

const GoogleAndFacebookButtons = ({ onFinish }: { onFinish?: () => void }) => {
  const { handleLoginGoogle } = useAuth()
  const { redirect } = useToRedirect()

  const handleSuccess = async (credentialResponse: any) => {
    try {
      const credential = credentialResponse.credential
      const userInfo = decodeGoogleJwt(credential)

      await handleLoginGoogle({
        firstName: userInfo.given_name,
        lastName: userInfo.family_name,
        accessToken: credential,
        email: userInfo.email,
        avatarUrl: userInfo.picture,
        method: 'google',
        acceptTerms: true,
        acceptConditions: true,
        kind: 'natural_person',
      })

      notify({ text: 'Conectado com sucesso!' }).success()
      if (onFinish) {
        onFinish()
      } else {
        redirect()
      }
    } catch (e) {
      notify({
        text: 'Não foi possível conectar com o Google. Tente novamente.',
      }).error()
    }
  }

  const handleError = () => {
    notify({
      text: 'Não foi possível conectar com o Google. Tente novamente.',
    }).error()
  }

  return (
    <>
      <Flex
        width="100%"
        justifyContent="space-between"
        alignContent="center"
        alignItems="center"
        gap="14px"
      >
        <Box w={['25%', '20%']} height="1px" background="black.200" />
        <retriever.p whiteSpace="nowrap" color="black.500" fontSize="16px">
          ou continuar com
        </retriever.p>
        <Box w={['25%', '20%']} height="1px" background="black.200" />
      </Flex>

      <Flex width="154px" justifyContent="center" alignItems="center">
        <retriever.div position="relative" w="100%" h="52px">
          <retriever.div
            d="flex"
            alignItems="center"
            justifyContent="center"
            gap="18px"
            radius={8}
            p={8}
            cursor="pointer"
            position="absolute"
            top="0"
            left="0"
            w="100%"
            h="100%"
            border="1px solid black.300"
            bg="black.0"
            color="black.500"
            fontFamily="'Montserrat', sans-serif"
            fontWeight={500}
            fontSize={14}
          >
            <GoogleIcon />
            <retriever.span fontSize={14} fontWeight={500}>
              Google
            </retriever.span>
          </retriever.div>

          <retriever.div
            position="absolute"
            top="0"
            left="0"
            w="100%"
            h="100%"
            zIndex={1}
            style={{
              width: '100%',
              height: '100%',
              opacity: 0,
              cursor: 'pointer',
              position: 'absolute',
              top: 0,
              left: 0,
            }}
          >
            <GoogleLogin onSuccess={handleSuccess} onError={handleError} />
          </retriever.div>
        </retriever.div>
      </Flex>
    </>
  )
}

export default GoogleAndFacebookButtons
